<template>
    <Teleport to="#menu-toggle-landing">
        <div class="menu-toggle-wrapper mega"
             v-on:click="handleMenuInteraction($event)"
             v-on:keydown="handleMenuInteraction($event)">
        <span id="menu-toggle" tabindex="0" class="action menu-toggle" aria-label="Toggle mega menu">
        <span class="menu-label">Menu</span>
        <span class="toggle-icon">
            <span></span>
            <span></span>
            <span></span>
        </span>
    </span>
        </div>
    </Teleport>
</template>

<script>

export default {
    data() {
        return {
            body: document.body,
        };
    },
    props: {},

    computed: {},

    mounted() {
        // console.log('menuToggle.vue mounted');
    },
    methods: {
        handleMenuInteraction(e) {
            // Scope action to mega-menu only
            if(this.$parent.isMegaMenu) {
                if (e.type === "keydown" && (e.key === 'Tab' && !e.shiftKey)) {
                    if (!this.body.classList.contains('mega-menu-open')) {
                        this.$parent.setFocusToNextItemOutsideMenu();
                    }
                } else if (e.type === "click" || (e.type === "keydown" && e.key === 'Enter')) {
                    // console.log('toggleMenu')
                    if (this.body.classList.contains('mega-menu-open')) {
                        this.$parent.closeMegaMenu();
                    } else {
                        this.body.classList.add('mega-menu-open');
                        this.$parent.activeMegaMenuParentLink = this.$parent.$refs.primaryNavigation.querySelector('.menu-link');
                        this.$parent.activeMegaMenuParentLink.focus();
                        this.$parent.activeMegaMenuParentLink.parentNode.classList.add('active');
                    }
                }
            }
        }
    }
}

</script>